import { IState } from '../../store';
import { ECpdDraftStatus } from '../../types/cpd/cpd';

export const selectIsCpdAvailable = (state: IState): boolean => state.cpd?.isCpdAvailable ?? false;

export const selectCpdDraftId = (state: IState): number | undefined => state.cpd?.modals.cpdDraftId;

export const selectCpdDraftStatus = (state: IState): ECpdDraftStatus => {
  return state.cpd?.modals.cpdDraftStatus ?? ECpdDraftStatus.init;
};

export const selectCpdSource = (state: IState): string | undefined => {
  return state.cpd?.modals.source;
};

export const selectCpdCianSource = (state: IState): string | undefined => {
  return state.cpd?.modals.cianSource;
};

export const selectIsCpdLabel = (state: IState): boolean => {
  return state.offerData.offer.isInCpd || false;
};

export const selectCpdLabelModalState = (state: IState) => {
  return state.cpd?.modals.labelModal;
};

export const selectCpdPrelandingModalState = (state: IState) => {
  return state.cpd?.modals.prelandingModal;
};

export const selectCustomCpdDealType = (state: IState) => {
  return state.cpd?.modals.customCpdDealType;
};
